import { GoodCheck } from "@/components/GoodCheck";

const STYLES = {
  CONFIRMED: {
    text: "text-success",
    bg: "bg-success-soft",
    border: "border-success/40",
    badge: "Confirmed",
    checked: true,
    box: "border-success bg-success text-white",
  },
  NO_CERTIFICATE: {
    text: "text-destructive",
    bg: "bg-destructive-soft",
    border: "border-destructive/40",
    badge: "Sold as-is",
    checked: false,
    box: "border-destructive text-destructive",
  },
  UNCONFIRMED: {
    text: "text-warning",
    bg: "bg-warning-soft",
    border: "border-warning/40",
    badge: "Confirm & add",
    checked: false,
    box: "border-warning text-warning",
  },
};

export const SafetyNoticeCard = ({ notice }) => {
  if (!notice) return null;
  const style = STYLES[notice.status] || STYLES.UNCONFIRMED;

  return (
    <div
      data-testid="safety-notice-card"
      data-status={notice.status}
      className={`rounded-xl border ${style.border} ${style.bg} p-5`}
    >
      <div className="flex items-start gap-3.5">
        {/* shield when a safety cert is confirmed, empty checkbox otherwise */}
        {style.checked ? (
          <GoodCheck className="mt-0.5 h-7 w-7" />
        ) : (
          <div
            className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-2 ${style.box}`}
            aria-hidden="true"
          />
        )}
        <div className="flex-1">
          <div className="flex items-center justify-between gap-3">
            <h4 className={`font-heading text-sm font-800 uppercase tracking-wide ${style.text}`}>
              {notice.title}
            </h4>
            <span
              data-testid="safety-notice-badge"
              className={`rounded-full border ${style.border} bg-background px-2.5 py-1 font-mono-plex text-[10px] font-600 uppercase tracking-[0.12em] ${style.text}`}
            >
              {style.badge}
            </span>
          </div>
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{notice.message}</p>
        </div>
      </div>
    </div>
  );
};
